// removed by extract-text-webpack-plugin
module.exports = {"container":"_12fD","light":"_3O0h","item":"cVX4","readMoreBorder":"_3Agd","bio":"_2Lc4","defaultSecondaryColor":"_2Tyk","readMoreLink":"llO7","topMenu":"_2Pia","quoteWrapper":"_2vb4","readMore":"ohjg","icon":"SVx3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CaseStudyCTA/styles.scss
// module id = 417
// module chunks = 0